<template>
  <div class="batigoSideBar">
    <nav>
      <div class="sidebar" v-if="getTabs">
        <div class="title">
          <h1>
            {{ $t("GENERAL") }}
            <svg
              class="bars"
              @click="changeTabs"
              xmlns="http://www.w3.org/2000/svg"
              width="27"
              height="18"
              viewBox="0 0 27 18"
            >
              <path
                id="Icon_material-menu"
                data-name="Icon material-menu"
                d="M4.5,27h27V24H4.5Zm0-7.5h27v-3H4.5ZM4.5,9v3h27V9Z"
                transform="translate(-4.5 -9)"
                fill="#fff"
              />
            </svg>
          </h1>

          <ul class="subtitle">
            <li>
              <router-link to="/Personal_information">
                <svg
                  class="svg"
                  xmlns="http://www.w3.org/2000/svg"
                  width="22.872"
                  height="22.872"
                  viewBox="0 0 22.872 22.872"
                >
                  <g
                    id="Icon_awesome-user-alt"
                    data-name="Icon awesome-user-alt"
                    fill="none"
                  >
                    <path
                      d="M11.436,12.866A6.433,6.433,0,1,0,5,6.433,6.435,6.435,0,0,0,11.436,12.866Zm5.718,1.43H14.693a7.776,7.776,0,0,1-6.513,0H5.718A5.718,5.718,0,0,0,0,20.013v.715a2.145,2.145,0,0,0,2.144,2.144H20.728a2.145,2.145,0,0,0,2.144-2.144v-.715A5.718,5.718,0,0,0,17.154,14.3Z"
                      stroke="none"
                    />
                    <path
                      d="M 20.72806549072266 21.37236022949219 C 21.08332633972168 21.37236022949219 21.37235641479492 21.08333969116211 21.37235641479492 20.72808074951172 L 21.37235641479492 20.01332092285156 C 21.37235641479492 17.68745994567871 19.48012542724609 15.7952299118042 17.15426635742188 15.7952299118042 L 15.00637722015381 15.7952299118042 C 13.86842823028564 16.26970291137695 12.66908931732178 16.50999069213867 11.43617630004883 16.50999069213867 C 10.20760059356689 16.50999069213867 9.008551597595215 16.26968002319336 7.867062568664551 15.7952299118042 L 5.718086242675781 15.7952299118042 C 3.392226219177246 15.7952299118042 1.499996304512024 17.68745994567871 1.499996304512024 20.01332092285156 L 1.499996304512024 20.72808074951172 C 1.499996304512024 21.08333969116211 1.789026260375977 21.37236022949219 2.144286394119263 21.37236022949219 L 20.72806549072266 21.37236022949219 M 11.43617630004883 11.36569976806641 C 14.15615653991699 11.36569976806641 16.36902618408203 9.152830123901367 16.36902618408203 6.432849884033203 C 16.36902618408203 3.712870121002197 14.15615653991699 1.50000011920929 11.43617630004883 1.50000011920929 C 8.716196060180664 1.50000011920929 6.503326416015625 3.712870121002197 6.503326416015625 6.432849884033203 C 6.503326416015625 9.152830123901367 8.716196060180664 11.36569976806641 11.43617630004883 11.36569976806641 M 20.72806549072266 22.87236022949219 L 2.144286394119263 22.87236022949219 C 0.9604563117027283 22.87236022949219 -3.699951093949494e-06 21.91189956665039 -3.699951093949494e-06 20.72808074951172 L -3.699951093949494e-06 20.01332092285156 C -3.699951093949494e-06 16.85497093200684 2.559736251831055 14.2952299118042 5.718086242675781 14.2952299118042 L 8.179546356201172 14.2952299118042 C 9.175745964050293 14.75088977813721 10.27468585968018 15.00998973846436 11.43617630004883 15.00998973846436 C 12.59766674041748 15.00998973846436 13.70107650756836 14.75088977813721 14.69280624389648 14.2952299118042 L 17.15426635742188 14.2952299118042 C 20.3126163482666 14.2952299118042 22.87235641479492 16.85497093200684 22.87235641479492 20.01332092285156 L 22.87235641479492 20.72808074951172 C 22.87235641479492 21.91189956665039 21.91189575195312 22.87236022949219 20.72806549072266 22.87236022949219 Z M 11.43617630004883 12.86569976806641 C 7.884706497192383 12.86569976806641 5.003326416015625 9.984319686889648 5.003326416015625 6.432849884033203 C 5.003326416015625 2.881380081176758 7.884706497192383 1.147460935158051e-07 11.43617630004883 1.147460935158051e-07 C 14.98764610290527 1.147460935158051e-07 17.86902618408203 2.881380081176758 17.86902618408203 6.432849884033203 C 17.86902618408203 9.984319686889648 14.98764610290527 12.86569976806641 11.43617630004883 12.86569976806641 Z"
                      stroke="none"
                      fill="#fff"
                    />
                  </g>
                </svg>

                {{ $t("PERSONAL_INFO") }}
              </router-link>
            </li>
            <li>
              <router-link v-if="isSuperAdmin" to="/Entreprise_list">
                <svg
                  class="svg"
                  xmlns="http://www.w3.org/2000/svg"
                  width="21.013"
                  height="23.872"
                  viewBox="0 0 21.013 23.872"
                >
                  <path
                    id="Icon_awesome-building"
                    data-name="Icon awesome-building"
                    d="M19.477,21.442h-.893V1.072A1.072,1.072,0,0,0,17.511,0H2.5A1.072,1.072,0,0,0,1.429,1.072v20.37H.536A.536.536,0,0,0,0,21.979v.893H20.013v-.893A.536.536,0,0,0,19.477,21.442ZM5.718,3.4a.536.536,0,0,1,.536-.536H8.041a.536.536,0,0,1,.536.536V5.182a.536.536,0,0,1-.536.536H6.254a.536.536,0,0,1-.536-.536Zm0,4.288a.536.536,0,0,1,.536-.536H8.041a.536.536,0,0,1,.536.536V9.47a.536.536,0,0,1-.536.536H6.254a.536.536,0,0,1-.536-.536Zm2.323,6.611H6.254a.536.536,0,0,1-.536-.536V11.972a.536.536,0,0,1,.536-.536H8.041a.536.536,0,0,1,.536.536v1.787A.536.536,0,0,1,8.041,14.295Zm3.4,7.147H8.577V17.69a.536.536,0,0,1,.536-.536H10.9a.536.536,0,0,1,.536.536Zm2.859-7.684a.536.536,0,0,1-.536.536H11.972a.536.536,0,0,1-.536-.536V11.972a.536.536,0,0,1,.536-.536h1.787a.536.536,0,0,1,.536.536Zm0-4.288a.536.536,0,0,1-.536.536H11.972a.536.536,0,0,1-.536-.536V7.684a.536.536,0,0,1,.536-.536h1.787a.536.536,0,0,1,.536.536Zm0-4.288a.536.536,0,0,1-.536.536H11.972a.536.536,0,0,1-.536-.536V3.4a.536.536,0,0,1,.536-.536h1.787a.536.536,0,0,1,.536.536Z"
                    transform="translate(0.5 0.5)"
                    fill="none"
                    stroke="#fff"
                    stroke-width="1"
                  />
                </svg>
                {{ $t("CUSTOMERS_BATIGO") }}
              </router-link>
              <router-link
                v-if="
                  isentrepriseAdmin ||
                  isAssistant ||
                  isTechnicien ||
                  isComptable ||
                  isCommercial
                "
                to="/Entreprise_information"
              >
                <svg
                  class="svg"
                  xmlns="http://www.w3.org/2000/svg"
                  width="21.013"
                  height="23.872"
                  viewBox="0 0 21.013 23.872"
                >
                  <path
                    id="Icon_awesome-building"
                    data-name="Icon awesome-building"
                    d="M19.477,21.442h-.893V1.072A1.072,1.072,0,0,0,17.511,0H2.5A1.072,1.072,0,0,0,1.429,1.072v20.37H.536A.536.536,0,0,0,0,21.979v.893H20.013v-.893A.536.536,0,0,0,19.477,21.442ZM5.718,3.4a.536.536,0,0,1,.536-.536H8.041a.536.536,0,0,1,.536.536V5.182a.536.536,0,0,1-.536.536H6.254a.536.536,0,0,1-.536-.536Zm0,4.288a.536.536,0,0,1,.536-.536H8.041a.536.536,0,0,1,.536.536V9.47a.536.536,0,0,1-.536.536H6.254a.536.536,0,0,1-.536-.536Zm2.323,6.611H6.254a.536.536,0,0,1-.536-.536V11.972a.536.536,0,0,1,.536-.536H8.041a.536.536,0,0,1,.536.536v1.787A.536.536,0,0,1,8.041,14.295Zm3.4,7.147H8.577V17.69a.536.536,0,0,1,.536-.536H10.9a.536.536,0,0,1,.536.536Zm2.859-7.684a.536.536,0,0,1-.536.536H11.972a.536.536,0,0,1-.536-.536V11.972a.536.536,0,0,1,.536-.536h1.787a.536.536,0,0,1,.536.536Zm0-4.288a.536.536,0,0,1-.536.536H11.972a.536.536,0,0,1-.536-.536V7.684a.536.536,0,0,1,.536-.536h1.787a.536.536,0,0,1,.536.536Zm0-4.288a.536.536,0,0,1-.536.536H11.972a.536.536,0,0,1-.536-.536V3.4a.536.536,0,0,1,.536-.536h1.787a.536.536,0,0,1,.536.536Z"
                    transform="translate(0.5 0.5)"
                    fill="none"
                    stroke="#fff"
                    stroke-width="1"
                  />
                </svg>
                {{ $t("COMPANY_INFO") }}
              </router-link>
              <router-link v-if="isCommercialBatigo" to="/commercial_list">
                <svg
                  class="svg"
                  xmlns="http://www.w3.org/2000/svg"
                  width="21.013"
                  height="23.872"
                  viewBox="0 0 21.013 23.872"
                >
                  <path
                    id="Icon_awesome-building"
                    data-name="Icon awesome-building"
                    d="M19.477,21.442h-.893V1.072A1.072,1.072,0,0,0,17.511,0H2.5A1.072,1.072,0,0,0,1.429,1.072v20.37H.536A.536.536,0,0,0,0,21.979v.893H20.013v-.893A.536.536,0,0,0,19.477,21.442ZM5.718,3.4a.536.536,0,0,1,.536-.536H8.041a.536.536,0,0,1,.536.536V5.182a.536.536,0,0,1-.536.536H6.254a.536.536,0,0,1-.536-.536Zm0,4.288a.536.536,0,0,1,.536-.536H8.041a.536.536,0,0,1,.536.536V9.47a.536.536,0,0,1-.536.536H6.254a.536.536,0,0,1-.536-.536Zm2.323,6.611H6.254a.536.536,0,0,1-.536-.536V11.972a.536.536,0,0,1,.536-.536H8.041a.536.536,0,0,1,.536.536v1.787A.536.536,0,0,1,8.041,14.295Zm3.4,7.147H8.577V17.69a.536.536,0,0,1,.536-.536H10.9a.536.536,0,0,1,.536.536Zm2.859-7.684a.536.536,0,0,1-.536.536H11.972a.536.536,0,0,1-.536-.536V11.972a.536.536,0,0,1,.536-.536h1.787a.536.536,0,0,1,.536.536Zm0-4.288a.536.536,0,0,1-.536.536H11.972a.536.536,0,0,1-.536-.536V7.684a.536.536,0,0,1,.536-.536h1.787a.536.536,0,0,1,.536.536Zm0-4.288a.536.536,0,0,1-.536.536H11.972a.536.536,0,0,1-.536-.536V3.4a.536.536,0,0,1,.536-.536h1.787a.536.536,0,0,1,.536.536Z"
                    transform="translate(0.5 0.5)"
                    fill="none"
                    stroke="#fff"
                    stroke-width="1"
                  />
                </svg>
                {{ $t("CUSTOMERS_BATIGO") }}
              </router-link>
            </li>
          </ul>
        </div>
        <div
          class="title"
          v-if="isSuperAdmin || isentrepriseAdmin || isAssistant"
        >
          <h1>{{ $t("ENTITY") }}</h1>
          <ul class="subtitle">
            <li>
              <router-link to="/fourniture">
                <svg
                  class="svg"
                  xmlns="http://www.w3.org/2000/svg"
                  width="22.005"
                  height="24.404"
                  viewBox="0 0 22.005 24.404"
                >
                  <g
                    id="Icon_feather-box"
                    data-name="Icon feather-box"
                    transform="translate(0.75 0.781)"
                  >
                    <path
                      id="Tracé_2292"
                      data-name="Tracé 2292"
                      d="M25.005,18.949V9.836a2.278,2.278,0,0,0-1.139-1.971L15.892,3.308a2.278,2.278,0,0,0-2.278,0L5.639,7.865A2.278,2.278,0,0,0,4.5,9.836v9.113A2.278,2.278,0,0,0,5.639,20.92l7.974,4.557a2.278,2.278,0,0,0,2.278,0l7.974-4.557a2.278,2.278,0,0,0,1.139-1.971Z"
                      transform="translate(-4.5 -3.003)"
                      fill="none"
                      stroke="#fff"
                      stroke-linecap="round"
                      stroke-linejoin="bevel"
                      stroke-width="1.5"
                    />
                    <path
                      id="Tracé_2293"
                      data-name="Tracé 2293"
                      d="M4.905,10.44l9.945,5.753L24.8,10.44"
                      transform="translate(-4.597 -4.792)"
                      fill="none"
                      stroke="#fff"
                      stroke-linecap="round"
                      stroke-linejoin="bevel"
                      stroke-width="1.5"
                    />
                    <path
                      id="Tracé_2294"
                      data-name="Tracé 2294"
                      d="M18,29.483V18"
                      transform="translate(-7.747 -6.611)"
                      fill="none"
                      stroke="#fff"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      stroke-width="1.5"
                    />
                  </g>
                </svg>

                {{ $t("Product management") }}
              </router-link>
            </li>
            <li v-if="isSuperAdmin">
              <router-link to="/categorie-article">
                <svg
                  class="svg"
                  xmlns="http://www.w3.org/2000/svg"
                  width="27.118"
                  height="23.915"
                  viewBox="0 0 27.118 23.915"
                >
                  <path
                    id="Icon_open-list-rich"
                    data-name="Icon open-list-rich"
                    d="M0,0V9.607H9.607V0ZM12.809,0V3.2H25.618V0Zm0,6.4v3.2h9.607V6.4ZM0,12.809v9.607H9.607V12.809Zm12.809,0v3.2H25.618v-3.2Zm0,6.4v3.2h9.607v-3.2Z"
                    transform="translate(0.75 0.75)"
                    fill="none"
                    stroke="#fff"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="1.5"
                  />
                </svg>

                {{ $t("Catégories produits") }}
              </router-link>
            </li>
            <li v-else>
              <router-link to="/visibilite-categories">
                <svg
                  class="svg"
                  xmlns="http://www.w3.org/2000/svg"
                  width="27.118"
                  height="23.915"
                  viewBox="0 0 27.118 23.915"
                >
                  <path
                    id="Icon_open-list-rich"
                    data-name="Icon open-list-rich"
                    d="M0,0V9.607H9.607V0ZM12.809,0V3.2H25.618V0Zm0,6.4v3.2h9.607V6.4ZM0,12.809v9.607H9.607V12.809Zm12.809,0v3.2H25.618v-3.2Zm0,6.4v3.2h9.607v-3.2Z"
                    transform="translate(0.75 0.75)"
                    fill="none"
                    stroke="#fff"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="1.5"
                  />
                </svg>

                {{ $t("CATVISIB") }}
              </router-link>
            </li>
            <li>
              <router-link to="/pieces">
                <svg
                  class="svg"
                  xmlns="http://www.w3.org/2000/svg"
                  width="24.88"
                  height="24.872"
                  viewBox="0 0 24.88 24.872"
                >
                  <g
                    id="Icon_ionic-ios-home"
                    data-name="Icon ionic-ios-home"
                    transform="translate(1 1)"
                  >
                    <g
                      id="Tracé_2295"
                      data-name="Tracé 2295"
                      transform="translate(-4.11 -4.221)"
                      fill="none"
                    >
                      <path
                        d="M15.685,7.306a.216.216,0,0,0-.275,0L6.832,14.167a.231.231,0,0,0-.082.17V26.984a.11.11,0,0,0,.11.11H12.8a.11.11,0,0,0,.11-.11v-7.7a.11.11,0,0,1,.11-.11h5.058a.11.11,0,0,1,.11.11v7.7a.11.11,0,0,0,.11.11h5.938a.11.11,0,0,0,.11-.11V14.338a.222.222,0,0,0-.082-.17Z"
                        stroke="none"
                      />
                      <path
                        d="M 15.54708194732666 7.256246566772461 C 15.49897480010986 7.256246566772461 15.45086669921875 7.272741317749023 15.40963172912598 7.305732727050781 L 6.83247184753418 14.16746139526367 C 6.782991409301758 14.21144104003906 6.750001907348633 14.27192115783691 6.750001907348633 14.3379020690918 L 6.750001907348633 26.98370170593262 C 6.750001907348633 27.04418182373047 6.799482345581055 27.09367179870605 6.859962463378906 27.09367179870605 L 12.79799270629883 27.09367179870605 C 12.85847282409668 27.09367179870605 12.90795135498047 27.04418182373047 12.90795135498047 26.98370170593262 L 12.90795135498047 19.28626251220703 C 12.90795135498047 19.22578048706055 12.95744132995605 19.17629241943359 13.01792144775391 19.17629241943359 L 18.07624053955078 19.17629241943359 C 18.13672256469727 19.17629241943359 18.18620300292969 19.22578048706055 18.18620300292969 19.28626251220703 L 18.18620300292969 26.98370170593262 C 18.18620300292969 27.04418182373047 18.23569107055664 27.09367179870605 18.29617309570312 27.09367179870605 L 24.23420143127441 27.09367179870605 C 24.29468154907227 27.09367179870605 24.34416198730469 27.04418182373047 24.34416198730469 26.98370170593262 L 24.34416198730469 14.3379020690918 C 24.34416198730469 14.27192115783691 24.31117248535156 14.20594215393066 24.26169204711914 14.16746139526367 L 15.68453216552734 7.305732727050781 C 15.64329719543457 7.272741317749023 15.59518909454346 7.256246566772461 15.54708194732666 7.256246566772461 M 15.54708194732666 6.256242752075195 C 15.82201194763184 6.256242752075195 16.09267234802246 6.351631164550781 16.30920219421387 6.52484130859375 L 24.88335037231445 13.38415908813477 C 25.17207527160645 13.61260223388672 25.34416198730469 13.96837043762207 25.34416198730469 14.3379020690918 L 25.34416198730469 26.98370170593262 C 25.34416198730469 27.59574127197266 24.84623146057129 28.09367179870605 24.23420143127441 28.09367179870605 L 18.29617309570312 28.09367179870605 C 17.68413162231445 28.09367179870605 17.18620300292969 27.59574127197266 17.18620300292969 26.98370170593262 L 17.18620300292969 20.17629241943359 L 13.90795135498047 20.17629241943359 L 13.90795135498047 26.98370170593262 C 13.90795135498047 27.59574127197266 13.4100227355957 28.09367179870605 12.79799270629883 28.09367179870605 L 6.859962463378906 28.09367179870605 C 6.247932434082031 28.09367179870605 5.750001907348633 27.59574127197266 5.750001907348633 26.98370170593262 L 5.750001907348633 14.3379020690918 C 5.750001907348633 13.99077224731445 5.902402877807617 13.65622138977051 6.168121337890625 13.4200325012207 L 6.207771301269531 13.3865909576416 L 14.78493118286133 6.524862289428711 C 15.00140190124512 6.351661682128906 15.27209186553955 6.256242752075195 15.54708194732666 6.256242752075195 Z"
                        stroke="none"
                        fill="#fff"
                      />
                    </g>
                    <g
                      id="Tracé_2296"
                      data-name="Tracé 2296"
                      transform="translate(-3.374 -3.375)"
                      fill="none"
                    >
                      <path
                        d="M25.956,11.963,15.564,3.639a1.207,1.207,0,0,0-1.506,0L9.533,7.317V5a.11.11,0,0,0-.11-.11h-3.3a.11.11,0,0,0-.11.11v5.069L3.666,12A.769.769,0,0,0,3.6,13.145a.765.765,0,0,0,.544.225.775.775,0,0,0,.484-.17L14.739,5.063a.1.1,0,0,1,.071-.022.133.133,0,0,1,.071.022l10.111,8.1a.775.775,0,0,0,.484.17.78.78,0,0,0,.775-.814A.781.781,0,0,0,25.956,11.963Z"
                        stroke="none"
                      />
                      <path
                        d="M 4.144470691680908 13.37068271636963 C 4.32041072845459 13.37068271636963 4.490860462188721 13.31020259857178 4.628310680389404 13.20024299621582 L 14.73946094512939 5.062942981719971 C 14.7669506072998 5.040952682495117 14.7889404296875 5.040952682495117 14.8109302520752 5.040952682495117 C 14.83292102813721 5.040952682495117 14.85492038726807 5.046442985534668 14.88241100311279 5.062942981719971 L 24.99355125427246 13.16725254058838 C 25.13101005554199 13.27721309661865 25.30145072937012 13.3376932144165 25.47739028930664 13.3376932144165 C 25.68082046508789 13.3376932144165 25.87326049804688 13.26072311401367 26.0217113494873 13.11227321624756 C 26.18115997314453 12.95832252502441 26.26362991333008 12.74389266967773 26.25263023376465 12.52396297454834 C 26.23614120483398 12.30403232574463 26.13168144226074 12.1006031036377 25.95573043823242 11.96315288543701 L 15.56418037414551 3.638912677764893 C 15.35525035858154 3.468472719192505 15.08584022521973 3.375002861022949 14.8109302520752 3.375002861022949 C 14.53602027893066 3.375002861022949 14.26661109924316 3.468472719192505 14.0576810836792 3.638912677764893 L 9.532680511474609 7.317192554473877 L 9.532680511474609 4.996963024139404 C 9.532680511474609 4.936482906341553 9.483201026916504 4.887002944946289 9.422720909118652 4.887002944946289 L 6.123820781707764 4.887002944946289 C 6.063340663909912 4.887002944946289 6.013850688934326 4.936482906341553 6.013850688934326 4.996963024139404 L 6.013850688934326 10.06628322601318 L 3.666130542755127 11.99614238739014 C 3.495690584182739 12.13359260559082 3.385720729827881 12.33702278137207 3.374730587005615 12.55695247650146 C 3.363730669021606 12.77688312530518 3.446210622787476 12.99131298065186 3.600150585174561 13.14526271820068 C 3.743110656738281 13.28821277618408 3.935540676116943 13.37068271636963 4.144470691680908 13.37068271636963 M 4.144470691680908 14.37068271636963 C 3.671740531921387 14.37068271636963 3.227310657501221 14.18661308288574 2.893070697784424 13.85239315032959 C 2.539360761642456 13.4986629486084 2.350910663604736 13.00830268859863 2.375980615615845 12.50700283050537 C 2.400884389877319 12.00852870941162 2.640934228897095 11.53992748260498 3.034765005111694 11.22064685821533 L 5.013850688934326 9.593810081481934 L 5.013850688934326 4.996963024139404 C 5.013850688934326 4.384932994842529 5.511780738830566 3.88700270652771 6.123820781707764 3.88700270652771 L 9.422720909118652 3.88700270652771 C 10.03475093841553 3.88700270652771 10.53268051147461 4.384932994842529 10.53268051147461 4.996963024139404 L 10.53268051147461 5.215603351593018 L 13.42691040039062 2.862942695617676 C 13.81214046478271 2.548682689666748 14.3041410446167 2.375002861022949 14.8109302520752 2.375002861022949 C 15.31571006774902 2.375002861022949 15.80583572387695 2.547322750091553 16.19171333312988 2.860311508178711 L 26.57770156860352 11.18009662628174 C 26.96755409240723 11.48753929138184 27.21237373352051 11.94961071014404 27.24983024597168 12.44919300079346 L 27.25138092041016 12.47401237487793 C 27.2767276763916 12.98083305358887 27.08416175842285 13.472825050354 26.72282791137695 13.82534694671631 C 26.38928031921387 14.15580081939697 25.94732284545898 14.3376932144165 25.47739028930664 14.3376932144165 C 25.07659149169922 14.3376932144165 24.68291091918945 14.19935321807861 24.36888122558594 13.94814300537109 L 14.81205940246582 6.28813362121582 L 5.255280494689941 13.97929286956787 C 4.938980579376221 14.23233318328857 4.545300483703613 14.37068271636963 4.144470691680908 14.37068271636963 Z"
                        stroke="none"
                        fill="#fff"
                      />
                    </g>
                  </g>
                </svg>

                {{ $t("ROOM") }}
              </router-link>
            </li>
            <li>
              <router-link to="/travaux">
                <svg
                  class="svg"
                  xmlns="http://www.w3.org/2000/svg"
                  width="23.874"
                  height="23.872"
                  viewBox="0 0 23.874 23.872"
                >
                  <path
                    id="Icon_ionic-ios-build"
                    data-name="Icon ionic-ios-build"
                    d="M24.988,7.944l-2.469,2.48a.228.228,0,0,1-.192.06l-2.551-.462a.223.223,0,0,1-.176-.176L19.143,7.3A.223.223,0,0,1,19.2,7.1l2.463-2.474a.436.436,0,0,0-.055-.665,3.139,3.139,0,0,0-1.748-.588.7.7,0,0,0-.11.005,5.3,5.3,0,0,0-3.3,1.633,5.314,5.314,0,0,0-1.237,5.746.871.871,0,0,1-.148,1.083C14.651,12.249,4.089,22.2,4.089,22.2a2.321,2.321,0,0,0-.005,3.348,2.463,2.463,0,0,0,1.721.7,2.116,2.116,0,0,0,1.627-.72S17.3,15.02,17.78,14.542a.851.851,0,0,1,.61-.28,1.037,1.037,0,0,1,.473.132,3.87,3.87,0,0,0,1.781.407,5.905,5.905,0,0,0,3.97-1.627,5.079,5.079,0,0,0,1.627-3.3,2.94,2.94,0,0,0-.588-1.88A.448.448,0,0,0,24.988,7.944ZM6.371,24.34a.774.774,0,1,1,0-1.094A.783.783,0,0,1,6.371,24.34Z"
                    transform="translate(-2.873 -2.875)"
                    fill="none"
                    stroke="#fff"
                    stroke-width="1"
                  />
                </svg>

                {{ $t("WORKS") }}
              </router-link>
            </li>
            <li v-if="isSuperAdmin">
              <router-link to="/gallery">
                <font-awesome-icon icon="image" class="svg" />
                {{ $t("GALLERY") }}
              </router-link>
            </li>
            <li v-if="isSuperAdmin">
              <router-link to="/fichier">
                <font-awesome-icon icon="list" class="svg" />
                {{ $t("CATEGORY_FILE") }}
              </router-link>
            </li>
          </ul>
        </div>
        <div class="title" v-if="isentrepriseAdmin">
          <h1>{{ $t("ACCESS") }}</h1>
          <ul class="subtitle">
            <li>
              <router-link to="/users">
                <svg
                  class="svg"
                  xmlns="http://www.w3.org/2000/svg"
                  width="25.865"
                  height="21.454"
                  viewBox="0 0 25.865 21.454"
                >
                  <g
                    id="Icon_feather-users"
                    data-name="Icon feather-users"
                    transform="translate(0.75 0.769)"
                  >
                    <path
                      id="Tracé_2297"
                      data-name="Tracé 2297"
                      d="M1.5,29.145V26.93A4.43,4.43,0,0,1,5.93,22.5h8.86a4.43,4.43,0,0,1,4.43,4.43v2.215"
                      transform="translate(5.145 -9.21)"
                      fill="none"
                      stroke="#fff"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      stroke-width="1.5"
                    />
                    <path
                      id="Tracé_2298"
                      data-name="Tracé 2298"
                      d="M7.5,8.93A4.43,4.43,0,1,0,11.93,4.5,4.43,4.43,0,0,0,7.5,8.93Z"
                      transform="translate(3.575 -4.5)"
                      fill="none"
                      stroke="#fff"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      stroke-width="1.5"
                    />
                    <path
                      id="Tracé_2299"
                      data-name="Tracé 2299"
                      d="M30,29.2V26.981A4.43,4.43,0,0,1,33.323,22.7"
                      transform="translate(-30 -9.261)"
                      fill="none"
                      stroke="#fff"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      stroke-width="1.5"
                    />
                    <path
                      id="Tracé_2300"
                      data-name="Tracé 2300"
                      d="M27.331,4.7a4.43,4.43,0,0,0,0,8.583"
                      transform="translate(-19.579 -4.551)"
                      fill="none"
                      stroke="#fff"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      stroke-width="1.5"
                    />
                  </g>
                </svg>
                {{ $t("USER") }}
              </router-link>
            </li>
          </ul>
        </div>
        <div class="title" v-if="isSuperAdmin">
          <h1>{{ $t("TRADUCTION") }}</h1>
          <ul class="subtitle">
            <li>
              <router-link to="/dictionnaire">
                <font-awesome-icon icon="fa-solid fa-book" class="svg" />
                {{ $t("DICTIONARY") }}
              </router-link>
            </li>
          </ul>
        </div>
      </div>

      <div class="sidebar minim" v-if="!getTabs">
        <div class="title">
          <h1>
            <svg
              class="bars"
              @click="changeTabs"
              xmlns="http://www.w3.org/2000/svg"
              width="27"
              height="18"
              viewBox="0 0 27 18"
            >
              <path
                id="Icon_material-menu"
                data-name="Icon material-menu"
                d="M4.5,27h27V24H4.5Zm0-7.5h27v-3H4.5ZM4.5,9v3h27V9Z"
                transform="translate(-4.5 -9)"
                fill="#fff"
              />
            </svg>
          </h1>

          <ul class="subtitle">
            <li :title="$t('PERSONAL_INFO')">
              <router-link to="/Personal_information">
                <svg
                  class="svg"
                  xmlns="http://www.w3.org/2000/svg"
                  width="22.872"
                  height="22.872"
                  viewBox="0 0 22.872 22.872"
                >
                  <g
                    id="Icon_awesome-user-alt"
                    data-name="Icon awesome-user-alt"
                    fill="none"
                  >
                    <path
                      d="M11.436,12.866A6.433,6.433,0,1,0,5,6.433,6.435,6.435,0,0,0,11.436,12.866Zm5.718,1.43H14.693a7.776,7.776,0,0,1-6.513,0H5.718A5.718,5.718,0,0,0,0,20.013v.715a2.145,2.145,0,0,0,2.144,2.144H20.728a2.145,2.145,0,0,0,2.144-2.144v-.715A5.718,5.718,0,0,0,17.154,14.3Z"
                      stroke="none"
                    />
                    <path
                      d="M 20.72806549072266 21.37236022949219 C 21.08332633972168 21.37236022949219 21.37235641479492 21.08333969116211 21.37235641479492 20.72808074951172 L 21.37235641479492 20.01332092285156 C 21.37235641479492 17.68745994567871 19.48012542724609 15.7952299118042 17.15426635742188 15.7952299118042 L 15.00637722015381 15.7952299118042 C 13.86842823028564 16.26970291137695 12.66908931732178 16.50999069213867 11.43617630004883 16.50999069213867 C 10.20760059356689 16.50999069213867 9.008551597595215 16.26968002319336 7.867062568664551 15.7952299118042 L 5.718086242675781 15.7952299118042 C 3.392226219177246 15.7952299118042 1.499996304512024 17.68745994567871 1.499996304512024 20.01332092285156 L 1.499996304512024 20.72808074951172 C 1.499996304512024 21.08333969116211 1.789026260375977 21.37236022949219 2.144286394119263 21.37236022949219 L 20.72806549072266 21.37236022949219 M 11.43617630004883 11.36569976806641 C 14.15615653991699 11.36569976806641 16.36902618408203 9.152830123901367 16.36902618408203 6.432849884033203 C 16.36902618408203 3.712870121002197 14.15615653991699 1.50000011920929 11.43617630004883 1.50000011920929 C 8.716196060180664 1.50000011920929 6.503326416015625 3.712870121002197 6.503326416015625 6.432849884033203 C 6.503326416015625 9.152830123901367 8.716196060180664 11.36569976806641 11.43617630004883 11.36569976806641 M 20.72806549072266 22.87236022949219 L 2.144286394119263 22.87236022949219 C 0.9604563117027283 22.87236022949219 -3.699951093949494e-06 21.91189956665039 -3.699951093949494e-06 20.72808074951172 L -3.699951093949494e-06 20.01332092285156 C -3.699951093949494e-06 16.85497093200684 2.559736251831055 14.2952299118042 5.718086242675781 14.2952299118042 L 8.179546356201172 14.2952299118042 C 9.175745964050293 14.75088977813721 10.27468585968018 15.00998973846436 11.43617630004883 15.00998973846436 C 12.59766674041748 15.00998973846436 13.70107650756836 14.75088977813721 14.69280624389648 14.2952299118042 L 17.15426635742188 14.2952299118042 C 20.3126163482666 14.2952299118042 22.87235641479492 16.85497093200684 22.87235641479492 20.01332092285156 L 22.87235641479492 20.72808074951172 C 22.87235641479492 21.91189956665039 21.91189575195312 22.87236022949219 20.72806549072266 22.87236022949219 Z M 11.43617630004883 12.86569976806641 C 7.884706497192383 12.86569976806641 5.003326416015625 9.984319686889648 5.003326416015625 6.432849884033203 C 5.003326416015625 2.881380081176758 7.884706497192383 1.147460935158051e-07 11.43617630004883 1.147460935158051e-07 C 14.98764610290527 1.147460935158051e-07 17.86902618408203 2.881380081176758 17.86902618408203 6.432849884033203 C 17.86902618408203 9.984319686889648 14.98764610290527 12.86569976806641 11.43617630004883 12.86569976806641 Z"
                      stroke="none"
                      fill="#fff"
                    />
                  </g>
                </svg>
              </router-link>
            </li>
            <li :title="$t('COMPANY_INFO')">
              <router-link v-if="isSuperAdmin" to="/Entreprise_list">
                <svg
                  class="svg"
                  xmlns="http://www.w3.org/2000/svg"
                  width="21.013"
                  height="23.872"
                  viewBox="0 0 21.013 23.872"
                >
                  <path
                    id="Icon_awesome-building"
                    data-name="Icon awesome-building"
                    d="M19.477,21.442h-.893V1.072A1.072,1.072,0,0,0,17.511,0H2.5A1.072,1.072,0,0,0,1.429,1.072v20.37H.536A.536.536,0,0,0,0,21.979v.893H20.013v-.893A.536.536,0,0,0,19.477,21.442ZM5.718,3.4a.536.536,0,0,1,.536-.536H8.041a.536.536,0,0,1,.536.536V5.182a.536.536,0,0,1-.536.536H6.254a.536.536,0,0,1-.536-.536Zm0,4.288a.536.536,0,0,1,.536-.536H8.041a.536.536,0,0,1,.536.536V9.47a.536.536,0,0,1-.536.536H6.254a.536.536,0,0,1-.536-.536Zm2.323,6.611H6.254a.536.536,0,0,1-.536-.536V11.972a.536.536,0,0,1,.536-.536H8.041a.536.536,0,0,1,.536.536v1.787A.536.536,0,0,1,8.041,14.295Zm3.4,7.147H8.577V17.69a.536.536,0,0,1,.536-.536H10.9a.536.536,0,0,1,.536.536Zm2.859-7.684a.536.536,0,0,1-.536.536H11.972a.536.536,0,0,1-.536-.536V11.972a.536.536,0,0,1,.536-.536h1.787a.536.536,0,0,1,.536.536Zm0-4.288a.536.536,0,0,1-.536.536H11.972a.536.536,0,0,1-.536-.536V7.684a.536.536,0,0,1,.536-.536h1.787a.536.536,0,0,1,.536.536Zm0-4.288a.536.536,0,0,1-.536.536H11.972a.536.536,0,0,1-.536-.536V3.4a.536.536,0,0,1,.536-.536h1.787a.536.536,0,0,1,.536.536Z"
                    transform="translate(0.5 0.5)"
                    fill="none"
                    stroke="#fff"
                    stroke-width="1"
                  />
                </svg>
              </router-link>
              <router-link
                v-if="
                  isentrepriseAdmin ||
                  isAssistant ||
                  isTechnicien ||
                  isComptable ||
                  isCommercial
                "
                to="/Entreprise_information"
              >
                <svg
                  class="svg"
                  xmlns="http://www.w3.org/2000/svg"
                  width="21.013"
                  height="23.872"
                  viewBox="0 0 21.013 23.872"
                >
                  <path
                    id="Icon_awesome-building"
                    data-name="Icon awesome-building"
                    d="M19.477,21.442h-.893V1.072A1.072,1.072,0,0,0,17.511,0H2.5A1.072,1.072,0,0,0,1.429,1.072v20.37H.536A.536.536,0,0,0,0,21.979v.893H20.013v-.893A.536.536,0,0,0,19.477,21.442ZM5.718,3.4a.536.536,0,0,1,.536-.536H8.041a.536.536,0,0,1,.536.536V5.182a.536.536,0,0,1-.536.536H6.254a.536.536,0,0,1-.536-.536Zm0,4.288a.536.536,0,0,1,.536-.536H8.041a.536.536,0,0,1,.536.536V9.47a.536.536,0,0,1-.536.536H6.254a.536.536,0,0,1-.536-.536Zm2.323,6.611H6.254a.536.536,0,0,1-.536-.536V11.972a.536.536,0,0,1,.536-.536H8.041a.536.536,0,0,1,.536.536v1.787A.536.536,0,0,1,8.041,14.295Zm3.4,7.147H8.577V17.69a.536.536,0,0,1,.536-.536H10.9a.536.536,0,0,1,.536.536Zm2.859-7.684a.536.536,0,0,1-.536.536H11.972a.536.536,0,0,1-.536-.536V11.972a.536.536,0,0,1,.536-.536h1.787a.536.536,0,0,1,.536.536Zm0-4.288a.536.536,0,0,1-.536.536H11.972a.536.536,0,0,1-.536-.536V7.684a.536.536,0,0,1,.536-.536h1.787a.536.536,0,0,1,.536.536Zm0-4.288a.536.536,0,0,1-.536.536H11.972a.536.536,0,0,1-.536-.536V3.4a.536.536,0,0,1,.536-.536h1.787a.536.536,0,0,1,.536.536Z"
                    transform="translate(0.5 0.5)"
                    fill="none"
                    stroke="#fff"
                    stroke-width="1"
                  />
                </svg>
              </router-link>
              <router-link v-if="isCommercialBatigo" to="/commercial_list">
                <svg
                  class="svg"
                  xmlns="http://www.w3.org/2000/svg"
                  width="21.013"
                  height="23.872"
                  viewBox="0 0 21.013 23.872"
                >
                  <path
                    id="Icon_awesome-building"
                    data-name="Icon awesome-building"
                    d="M19.477,21.442h-.893V1.072A1.072,1.072,0,0,0,17.511,0H2.5A1.072,1.072,0,0,0,1.429,1.072v20.37H.536A.536.536,0,0,0,0,21.979v.893H20.013v-.893A.536.536,0,0,0,19.477,21.442ZM5.718,3.4a.536.536,0,0,1,.536-.536H8.041a.536.536,0,0,1,.536.536V5.182a.536.536,0,0,1-.536.536H6.254a.536.536,0,0,1-.536-.536Zm0,4.288a.536.536,0,0,1,.536-.536H8.041a.536.536,0,0,1,.536.536V9.47a.536.536,0,0,1-.536.536H6.254a.536.536,0,0,1-.536-.536Zm2.323,6.611H6.254a.536.536,0,0,1-.536-.536V11.972a.536.536,0,0,1,.536-.536H8.041a.536.536,0,0,1,.536.536v1.787A.536.536,0,0,1,8.041,14.295Zm3.4,7.147H8.577V17.69a.536.536,0,0,1,.536-.536H10.9a.536.536,0,0,1,.536.536Zm2.859-7.684a.536.536,0,0,1-.536.536H11.972a.536.536,0,0,1-.536-.536V11.972a.536.536,0,0,1,.536-.536h1.787a.536.536,0,0,1,.536.536Zm0-4.288a.536.536,0,0,1-.536.536H11.972a.536.536,0,0,1-.536-.536V7.684a.536.536,0,0,1,.536-.536h1.787a.536.536,0,0,1,.536.536Zm0-4.288a.536.536,0,0,1-.536.536H11.972a.536.536,0,0,1-.536-.536V3.4a.536.536,0,0,1,.536-.536h1.787a.536.536,0,0,1,.536.536Z"
                    transform="translate(0.5 0.5)"
                    fill="none"
                    stroke="#fff"
                    stroke-width="1"
                  />
                </svg>
              </router-link>
            </li>
          </ul>
        </div>
        <div
          class="title"
          v-if="isSuperAdmin || isentrepriseAdmin || isAssistant"
        >
          <h1></h1>
          <ul class="subtitle">
            <li :title="$t('Product management')">
              <router-link to="/fourniture">
                <svg
                  class="svg"
                  xmlns="http://www.w3.org/2000/svg"
                  width="22.005"
                  height="24.404"
                  viewBox="0 0 22.005 24.404"
                >
                  <g
                    id="Icon_feather-box"
                    data-name="Icon feather-box"
                    transform="translate(0.75 0.781)"
                  >
                    <path
                      id="Tracé_2292"
                      data-name="Tracé 2292"
                      d="M25.005,18.949V9.836a2.278,2.278,0,0,0-1.139-1.971L15.892,3.308a2.278,2.278,0,0,0-2.278,0L5.639,7.865A2.278,2.278,0,0,0,4.5,9.836v9.113A2.278,2.278,0,0,0,5.639,20.92l7.974,4.557a2.278,2.278,0,0,0,2.278,0l7.974-4.557a2.278,2.278,0,0,0,1.139-1.971Z"
                      transform="translate(-4.5 -3.003)"
                      fill="none"
                      stroke="#fff"
                      stroke-linecap="round"
                      stroke-linejoin="bevel"
                      stroke-width="1.5"
                    />
                    <path
                      id="Tracé_2293"
                      data-name="Tracé 2293"
                      d="M4.905,10.44l9.945,5.753L24.8,10.44"
                      transform="translate(-4.597 -4.792)"
                      fill="none"
                      stroke="#fff"
                      stroke-linecap="round"
                      stroke-linejoin="bevel"
                      stroke-width="1.5"
                    />
                    <path
                      id="Tracé_2294"
                      data-name="Tracé 2294"
                      d="M18,29.483V18"
                      transform="translate(-7.747 -6.611)"
                      fill="none"
                      stroke="#fff"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      stroke-width="1.5"
                    />
                  </g>
                </svg>
              </router-link>
            </li>
            <li :title="$t('Catégories produits')" v-if="isSuperAdmin">
              <router-link to="/categorie-article">
                <svg
                  class="svg"
                  xmlns="http://www.w3.org/2000/svg"
                  width="27.118"
                  height="23.915"
                  viewBox="0 0 27.118 23.915"
                >
                  <path
                    id="Icon_open-list-rich"
                    data-name="Icon open-list-rich"
                    d="M0,0V9.607H9.607V0ZM12.809,0V3.2H25.618V0Zm0,6.4v3.2h9.607V6.4ZM0,12.809v9.607H9.607V12.809Zm12.809,0v3.2H25.618v-3.2Zm0,6.4v3.2h9.607v-3.2Z"
                    transform="translate(0.75 0.75)"
                    fill="none"
                    stroke="#fff"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="1.5"
                  />
                </svg>
              </router-link>
            </li>
            <li :title="$t('CATVISIB')" v-else>
              <router-link to="/visibilite-categories">
                <svg
                  class="svg"
                  xmlns="http://www.w3.org/2000/svg"
                  width="27.118"
                  height="23.915"
                  viewBox="0 0 27.118 23.915"
                >
                  <path
                    id="Icon_open-list-rich"
                    data-name="Icon open-list-rich"
                    d="M0,0V9.607H9.607V0ZM12.809,0V3.2H25.618V0Zm0,6.4v3.2h9.607V6.4ZM0,12.809v9.607H9.607V12.809Zm12.809,0v3.2H25.618v-3.2Zm0,6.4v3.2h9.607v-3.2Z"
                    transform="translate(0.75 0.75)"
                    fill="none"
                    stroke="#fff"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="1.5"
                  />
                </svg>
              </router-link>
            </li>
            <li :title="$t('ROOM')">
              <router-link to="/pieces">
                <svg
                  class="svg"
                  xmlns="http://www.w3.org/2000/svg"
                  width="24.88"
                  height="24.872"
                  viewBox="0 0 24.88 24.872"
                >
                  <g
                    id="Icon_ionic-ios-home"
                    data-name="Icon ionic-ios-home"
                    transform="translate(1 1)"
                  >
                    <g
                      id="Tracé_2295"
                      data-name="Tracé 2295"
                      transform="translate(-4.11 -4.221)"
                      fill="none"
                    >
                      <path
                        d="M15.685,7.306a.216.216,0,0,0-.275,0L6.832,14.167a.231.231,0,0,0-.082.17V26.984a.11.11,0,0,0,.11.11H12.8a.11.11,0,0,0,.11-.11v-7.7a.11.11,0,0,1,.11-.11h5.058a.11.11,0,0,1,.11.11v7.7a.11.11,0,0,0,.11.11h5.938a.11.11,0,0,0,.11-.11V14.338a.222.222,0,0,0-.082-.17Z"
                        stroke="none"
                      />
                      <path
                        d="M 15.54708194732666 7.256246566772461 C 15.49897480010986 7.256246566772461 15.45086669921875 7.272741317749023 15.40963172912598 7.305732727050781 L 6.83247184753418 14.16746139526367 C 6.782991409301758 14.21144104003906 6.750001907348633 14.27192115783691 6.750001907348633 14.3379020690918 L 6.750001907348633 26.98370170593262 C 6.750001907348633 27.04418182373047 6.799482345581055 27.09367179870605 6.859962463378906 27.09367179870605 L 12.79799270629883 27.09367179870605 C 12.85847282409668 27.09367179870605 12.90795135498047 27.04418182373047 12.90795135498047 26.98370170593262 L 12.90795135498047 19.28626251220703 C 12.90795135498047 19.22578048706055 12.95744132995605 19.17629241943359 13.01792144775391 19.17629241943359 L 18.07624053955078 19.17629241943359 C 18.13672256469727 19.17629241943359 18.18620300292969 19.22578048706055 18.18620300292969 19.28626251220703 L 18.18620300292969 26.98370170593262 C 18.18620300292969 27.04418182373047 18.23569107055664 27.09367179870605 18.29617309570312 27.09367179870605 L 24.23420143127441 27.09367179870605 C 24.29468154907227 27.09367179870605 24.34416198730469 27.04418182373047 24.34416198730469 26.98370170593262 L 24.34416198730469 14.3379020690918 C 24.34416198730469 14.27192115783691 24.31117248535156 14.20594215393066 24.26169204711914 14.16746139526367 L 15.68453216552734 7.305732727050781 C 15.64329719543457 7.272741317749023 15.59518909454346 7.256246566772461 15.54708194732666 7.256246566772461 M 15.54708194732666 6.256242752075195 C 15.82201194763184 6.256242752075195 16.09267234802246 6.351631164550781 16.30920219421387 6.52484130859375 L 24.88335037231445 13.38415908813477 C 25.17207527160645 13.61260223388672 25.34416198730469 13.96837043762207 25.34416198730469 14.3379020690918 L 25.34416198730469 26.98370170593262 C 25.34416198730469 27.59574127197266 24.84623146057129 28.09367179870605 24.23420143127441 28.09367179870605 L 18.29617309570312 28.09367179870605 C 17.68413162231445 28.09367179870605 17.18620300292969 27.59574127197266 17.18620300292969 26.98370170593262 L 17.18620300292969 20.17629241943359 L 13.90795135498047 20.17629241943359 L 13.90795135498047 26.98370170593262 C 13.90795135498047 27.59574127197266 13.4100227355957 28.09367179870605 12.79799270629883 28.09367179870605 L 6.859962463378906 28.09367179870605 C 6.247932434082031 28.09367179870605 5.750001907348633 27.59574127197266 5.750001907348633 26.98370170593262 L 5.750001907348633 14.3379020690918 C 5.750001907348633 13.99077224731445 5.902402877807617 13.65622138977051 6.168121337890625 13.4200325012207 L 6.207771301269531 13.3865909576416 L 14.78493118286133 6.524862289428711 C 15.00140190124512 6.351661682128906 15.27209186553955 6.256242752075195 15.54708194732666 6.256242752075195 Z"
                        stroke="none"
                        fill="#fff"
                      />
                    </g>
                    <g
                      id="Tracé_2296"
                      data-name="Tracé 2296"
                      transform="translate(-3.374 -3.375)"
                      fill="none"
                    >
                      <path
                        d="M25.956,11.963,15.564,3.639a1.207,1.207,0,0,0-1.506,0L9.533,7.317V5a.11.11,0,0,0-.11-.11h-3.3a.11.11,0,0,0-.11.11v5.069L3.666,12A.769.769,0,0,0,3.6,13.145a.765.765,0,0,0,.544.225.775.775,0,0,0,.484-.17L14.739,5.063a.1.1,0,0,1,.071-.022.133.133,0,0,1,.071.022l10.111,8.1a.775.775,0,0,0,.484.17.78.78,0,0,0,.775-.814A.781.781,0,0,0,25.956,11.963Z"
                        stroke="none"
                      />
                      <path
                        d="M 4.144470691680908 13.37068271636963 C 4.32041072845459 13.37068271636963 4.490860462188721 13.31020259857178 4.628310680389404 13.20024299621582 L 14.73946094512939 5.062942981719971 C 14.7669506072998 5.040952682495117 14.7889404296875 5.040952682495117 14.8109302520752 5.040952682495117 C 14.83292102813721 5.040952682495117 14.85492038726807 5.046442985534668 14.88241100311279 5.062942981719971 L 24.99355125427246 13.16725254058838 C 25.13101005554199 13.27721309661865 25.30145072937012 13.3376932144165 25.47739028930664 13.3376932144165 C 25.68082046508789 13.3376932144165 25.87326049804688 13.26072311401367 26.0217113494873 13.11227321624756 C 26.18115997314453 12.95832252502441 26.26362991333008 12.74389266967773 26.25263023376465 12.52396297454834 C 26.23614120483398 12.30403232574463 26.13168144226074 12.1006031036377 25.95573043823242 11.96315288543701 L 15.56418037414551 3.638912677764893 C 15.35525035858154 3.468472719192505 15.08584022521973 3.375002861022949 14.8109302520752 3.375002861022949 C 14.53602027893066 3.375002861022949 14.26661109924316 3.468472719192505 14.0576810836792 3.638912677764893 L 9.532680511474609 7.317192554473877 L 9.532680511474609 4.996963024139404 C 9.532680511474609 4.936482906341553 9.483201026916504 4.887002944946289 9.422720909118652 4.887002944946289 L 6.123820781707764 4.887002944946289 C 6.063340663909912 4.887002944946289 6.013850688934326 4.936482906341553 6.013850688934326 4.996963024139404 L 6.013850688934326 10.06628322601318 L 3.666130542755127 11.99614238739014 C 3.495690584182739 12.13359260559082 3.385720729827881 12.33702278137207 3.374730587005615 12.55695247650146 C 3.363730669021606 12.77688312530518 3.446210622787476 12.99131298065186 3.600150585174561 13.14526271820068 C 3.743110656738281 13.28821277618408 3.935540676116943 13.37068271636963 4.144470691680908 13.37068271636963 M 4.144470691680908 14.37068271636963 C 3.671740531921387 14.37068271636963 3.227310657501221 14.18661308288574 2.893070697784424 13.85239315032959 C 2.539360761642456 13.4986629486084 2.350910663604736 13.00830268859863 2.375980615615845 12.50700283050537 C 2.400884389877319 12.00852870941162 2.640934228897095 11.53992748260498 3.034765005111694 11.22064685821533 L 5.013850688934326 9.593810081481934 L 5.013850688934326 4.996963024139404 C 5.013850688934326 4.384932994842529 5.511780738830566 3.88700270652771 6.123820781707764 3.88700270652771 L 9.422720909118652 3.88700270652771 C 10.03475093841553 3.88700270652771 10.53268051147461 4.384932994842529 10.53268051147461 4.996963024139404 L 10.53268051147461 5.215603351593018 L 13.42691040039062 2.862942695617676 C 13.81214046478271 2.548682689666748 14.3041410446167 2.375002861022949 14.8109302520752 2.375002861022949 C 15.31571006774902 2.375002861022949 15.80583572387695 2.547322750091553 16.19171333312988 2.860311508178711 L 26.57770156860352 11.18009662628174 C 26.96755409240723 11.48753929138184 27.21237373352051 11.94961071014404 27.24983024597168 12.44919300079346 L 27.25138092041016 12.47401237487793 C 27.2767276763916 12.98083305358887 27.08416175842285 13.472825050354 26.72282791137695 13.82534694671631 C 26.38928031921387 14.15580081939697 25.94732284545898 14.3376932144165 25.47739028930664 14.3376932144165 C 25.07659149169922 14.3376932144165 24.68291091918945 14.19935321807861 24.36888122558594 13.94814300537109 L 14.81205940246582 6.28813362121582 L 5.255280494689941 13.97929286956787 C 4.938980579376221 14.23233318328857 4.545300483703613 14.37068271636963 4.144470691680908 14.37068271636963 Z"
                        stroke="none"
                        fill="#fff"
                      />
                    </g>
                  </g>
                </svg>
              </router-link>
            </li>
            <li :title="$t('WORKS')">
              <router-link to="/travaux">
                <svg
                  class="svg"
                  xmlns="http://www.w3.org/2000/svg"
                  width="23.874"
                  height="23.872"
                  viewBox="0 0 23.874 23.872"
                >
                  <path
                    id="Icon_ionic-ios-build"
                    data-name="Icon ionic-ios-build"
                    d="M24.988,7.944l-2.469,2.48a.228.228,0,0,1-.192.06l-2.551-.462a.223.223,0,0,1-.176-.176L19.143,7.3A.223.223,0,0,1,19.2,7.1l2.463-2.474a.436.436,0,0,0-.055-.665,3.139,3.139,0,0,0-1.748-.588.7.7,0,0,0-.11.005,5.3,5.3,0,0,0-3.3,1.633,5.314,5.314,0,0,0-1.237,5.746.871.871,0,0,1-.148,1.083C14.651,12.249,4.089,22.2,4.089,22.2a2.321,2.321,0,0,0-.005,3.348,2.463,2.463,0,0,0,1.721.7,2.116,2.116,0,0,0,1.627-.72S17.3,15.02,17.78,14.542a.851.851,0,0,1,.61-.28,1.037,1.037,0,0,1,.473.132,3.87,3.87,0,0,0,1.781.407,5.905,5.905,0,0,0,3.97-1.627,5.079,5.079,0,0,0,1.627-3.3,2.94,2.94,0,0,0-.588-1.88A.448.448,0,0,0,24.988,7.944ZM6.371,24.34a.774.774,0,1,1,0-1.094A.783.783,0,0,1,6.371,24.34Z"
                    transform="translate(-2.873 -2.875)"
                    fill="none"
                    stroke="#fff"
                    stroke-width="1"
                  />
                </svg>
              </router-link>
            </li>

            <li :title="$t('GALLERY')" v-if="isSuperAdmin">
              <router-link to="/gallery">
                <font-awesome-icon icon="image" class="svg" />
              </router-link>
            </li>
            <li :title="$t('CATEGORY_FILE')" v-if="isSuperAdmin">
              <router-link to="/fichier">
                <font-awesome-icon icon="list" class="svg" />
              </router-link>
            </li>
          </ul>
        </div>
        <div class="title" v-if="isentrepriseAdmin">
          <h1></h1>
          <ul class="subtitle">
            <li :title="$t('USER')">
              <router-link to="/users">
                <svg
                  class="svg"
                  xmlns="http://www.w3.org/2000/svg"
                  width="25.865"
                  height="21.454"
                  viewBox="0 0 25.865 21.454"
                >
                  <g
                    id="Icon_feather-users"
                    data-name="Icon feather-users"
                    transform="translate(0.75 0.769)"
                  >
                    <path
                      id="Tracé_2297"
                      data-name="Tracé 2297"
                      d="M1.5,29.145V26.93A4.43,4.43,0,0,1,5.93,22.5h8.86a4.43,4.43,0,0,1,4.43,4.43v2.215"
                      transform="translate(5.145 -9.21)"
                      fill="none"
                      stroke="#fff"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      stroke-width="1.5"
                    />
                    <path
                      id="Tracé_2298"
                      data-name="Tracé 2298"
                      d="M7.5,8.93A4.43,4.43,0,1,0,11.93,4.5,4.43,4.43,0,0,0,7.5,8.93Z"
                      transform="translate(3.575 -4.5)"
                      fill="none"
                      stroke="#fff"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      stroke-width="1.5"
                    />
                    <path
                      id="Tracé_2299"
                      data-name="Tracé 2299"
                      d="M30,29.2V26.981A4.43,4.43,0,0,1,33.323,22.7"
                      transform="translate(-30 -9.261)"
                      fill="none"
                      stroke="#fff"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      stroke-width="1.5"
                    />
                    <path
                      id="Tracé_2300"
                      data-name="Tracé 2300"
                      d="M27.331,4.7a4.43,4.43,0,0,0,0,8.583"
                      transform="translate(-19.579 -4.551)"
                      fill="none"
                      stroke="#fff"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      stroke-width="1.5"
                    />
                  </g>
                </svg>
              </router-link>
            </li>
            <!-- <li
              :title="$t('SUBSC_MANAGEMENT')"
              v-if="isFirstAdmin"
            >
              <router-link to="/abonnements">
                <font-awesome-icon
                  icon="fa-solid fa-credit-card"
                  class="svg"
                />
              </router-link>
            </li> -->
          </ul>
        </div>
        <div class="title" v-if="isSuperAdmin">
          <h1></h1>
          <ul class="subtitle">
            <li :title="$t('DICTIONARY')">
              <router-link to="/dictionnaire">
                <font-awesome-icon icon="fa-solid fa-book" class="svg" />
              </router-link>
            </li>
          </ul>
        </div>
      </div>
    </nav>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";

export default {
  methods: {
    ...mapActions(["changeTabs", "saveLang", "pays"]),
  },
  computed: {
    ...mapGetters([
      "getOnlineUser",
      "getTabs",
      "getAllLangue",
      "getLoadingdictionnaire",
      "getSelectedLang",
    ]),
    utilsRouterLinkActive: function () {
      return this.$route.name;
    },
    isSuperAdmin() {
      return this.getOnlineUser.role == "user.super-admin";
    },
    isentrepriseAdmin() {
      return this.getOnlineUser.role == "user.entreprise-admin";
    },
    isFirstAdmin() {
      return this.getOnlineUser.first_admin;
    },
    isAssistant() {
      return this.getOnlineUser.role == "user.assistant";
    },
    isTechnicien() {
      return this.getOnlineUser.role == "user.technicien";
    },
    isComptable() {
      return this.getOnlineUser.role == "user.comptable";
    },
    isApporteurAffaire() {
      return this.getOnlineUser.role == "user.apporteur-affaire";
    },
    isCommercialBatigo() {
      return this.getOnlineUser.role == "user.commercial-batigo";
    },
    isCommercial() {
      return this.getOnlineUser.role == "user.commercial-entreprise";
    },
  },
};
</script>

<style lang="scss" scoped>
.batigoSideBar {
  @media only screen and (max-width: 900px) {
    display: none;
  }
}
.minim {
  padding: 42px 0 !important;
  width: 64px !important;

  .bars {
    top: -32px !important;
    left: 18px !important;
  }

  h1::after {
    margin: 4px 0 0 !important;
  }
  a {
    justify-content: center !important;

    .svg {
      margin: 0 !important;
    }
  }
}

.sidebar {
  background-color: #28367a;
  width: 220px;
  height: 100vh;
  margin-top: 57px;
  padding: 24px 0;
  position: fixed;

  ul {
    margin: 0;
  }

  .subtitle {
    list-style: none;
  }

  h1 {
    padding: 0 10px;
    margin: 0;
    position: relative;
    font-size: 16px;
    font-weight: 600;
    color: #616a92;
  }

  h1::after {
    content: "";
    border-top: 2px solid #fff;
    display: flex;
    margin: 0.5rem 0 0;
    width: 100%;
  }

  a {
    padding-left: 32px;
    display: flex;
    justify-content: flex-start;
    font-size: 12px;
    color: #fff;
    transition: all 0.2s ease;
    text-decoration: none;
    padding: 12px 16px;

    &:hover {
      background-color: #3a4891;
    }

    .svg {
      width: 20px;
      height: 20px;
      margin-right: 14px;
    }

    &.router-link-active {
      position: relative;
      background-color: #3a4891;

      &::after {
        content: "";
        width: 6px;
        height: 100%;
        background-color: #e4261b;
        position: absolute;
        left: 0;
        top: 0;
      }
    }
  }

  .bars {
    cursor: pointer;
    position: absolute;
    top: 0;
    top: -8px;
    right: 20px;
    width: 24px;
    height: 20px;
    color: #fff;
  }
}

.langues {
  .lang {
    padding: 10px 24px;
    color: #62646a;
    cursor: pointer;
    border-radius: 5px;
    font-size: 14px;

    &:hover {
      background-color: #e9ecef;
    }
  }
}
</style>
